import { createAsyncThunk } from '@reduxjs/toolkit';
import { ReferralApi } from 'api/ReferralApi';

import { ErrorResponse } from './ErrorResponse';

export const createGetReferralLinkThunk = (api: ReferralApi) =>
  createAsyncThunk('referral/getReferralLink', async (applicationId: string, thunkApi) => {
    try {
      return await api.getReferralLink(applicationId);
    } catch (error: unknown) {
      return thunkApi.rejectWithValue((error as ErrorResponse).response.data);
    }
  });
